module.exports = __webpack_public_path__ + "static/img/cstSer_bg_06.3c295d63.svg";